import { PointOfInterest, Population } from '../../domain/entities/population';

import { asRecord, readArray, readId, readString } from './raw-json';

export function toPointOfInterest(raw: unknown): PointOfInterest | null {
  const record = asRecord(raw);
  const id = readId(record);
  const title = readString(record, 'title', 'name', 'label');

  if (id === null || title === null) {
    return null;
  }
  return { id, title };
}

export function toPopulation(raw: unknown): Population | null {
  const record = asRecord(raw);
  const id = readId(record);
  const name = readString(record, 'name', 'title', 'label');

  if (id === null || name === null) {
    return null;
  }

  return {
    id,
    name,
    pointsOfInterest: readArray(record, 'pois', 'resources', 'recursos')
      .map(toPointOfInterest)
      .filter((poi): poi is PointOfInterest => poi !== null),
  };
}
